import {AfterViewInit, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {GlobalFunction} from '../../../common/core/global_function';
import {MessageCloseComponent, MessageconfirmComponent} from 'app/common/component/popup/popup.component';
import {Observable} from 'rxjs';
import "rxjs/add/operator/debounceTime";
import {BaseComponent} from '../../base.component';
import {AppGlobal} from '../../../common/app.global';
import {Location} from '@angular/common';

declare var $: any;

export class AdmintableComponent extends BaseComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild('tablelist') tablelist: any;

    @ViewChild('obj_message_confirm') obj_message_confirm: MessageconfirmComponent;
    @ViewChild('obj_message_close') obj_message_close: MessageCloseComponent;
    listData: any = [];
    columns: any = [];
    model: any;
    order_default: any = '';
    expand: any = '';
    e: any;
    where: any = '';
    total: number = 0;
    constructor(public route: ActivatedRoute,
                public router: Router,
                public appGlobal: AppGlobal,
                public _location: Location,) {
      super(appGlobal, route, router, _location);
      this.latestPageChangeTimestamp = new Date().getTime();
    }
    sub: any;
    academic_years: any = [];

    @Input()
    set ListData(data: Observable<any> | any) {
      this.listData = data;
    }
    get ListData() {
      return this.listData;
      }

    _data_query: any= true;
    @Input()
    set data_query(data: Observable<any> | any) {
      this._data_query = data;
    }
    get data_query() {
      return this._data_query;
    }

    ngOnInit(): void {
    }

    ngAfterViewInit() {
    }

    currentAcademyYearValue;
    loadingData: boolean = false;

    itemCountPerPage: number = 15;
    currentPage: number = 0;
    private latestPageChangeTimestamp: number;

    protected routeParams: any;
    protected baseCondition: any;

    loadPage(conditionChanged?: boolean) {
        if (conditionChanged) {
            const params = this.routeParams;
            this.baseCondition = this.getCondition(params);
            this.currentPage = 0;
        }

        const condition = Object.assign({}, this.baseCondition);
        this.listData = [];
        this.loadingData = true;
        this.tablelist.loading = true;
        this.tablelist.currentPage = this.currentPage;
        this.tablelist.itemCountPerPage = this.itemCountPerPage;
        const that = this;
        const pageChangeTimestamp = new Date().getTime();
        const itemCountPerPage = that.itemCountPerPage;
        const offset = that.currentPage * itemCountPerPage;
        return that.model.findAll(condition, itemCountPerPage, offset).then(rs => {
            if (pageChangeTimestamp >= that.latestPageChangeTimestamp) {
                const total = rs.total || 0;
                that.total = total;
                that.listData = rs;
                that.tablelist.loading = false;
                that.tablelist.itemCountTotal = total;
                that.loadingData = false;
                that.latestPageChangeTimestamp = pageChangeTimestamp;
            }
        });
    }

    setInit() {
        const that = this;
        // prevent the listener being called multiple times for a single change event (angular bug?)
        this.sub = this.route.params.debounceTime(40).subscribe(params => {
            that.routeParams = params;
            that.loadPage(true);
        });
        this.sub.add(this.tablelist.pageChange.subscribe((evt: any) => {
            that.currentPage = evt.currentPage;
            that.itemCountPerPage = evt.itemCountPerPage;
            that.loadPage();
        }));
    }

    getCondition(params) {
        let rule = this.model.rule();
        let condition: any = {};
        let orderBy = params.order_by || this.order_default;
        if (orderBy) {
            condition.$orderby = orderBy;
        }
        if (this.expand) {
            condition.$expand = this.expand;
        }
        if (this.where) {
            condition.where = this.where;
        }
        if (params) {
            for (let k in params) {
                if (params.hasOwnProperty(k) && !GlobalFunction.contains(k, ['order_by', 'limit', 'offset'])) {
                    if (rule[k] && rule[k].search) {
                        let key;
                        // key = '$';
                        if (k == 'alpha') {
                            key = this.model.name_alpha;
                        } else {
                            key = k;
                        }
                        if (typeof (rule[k].search) === 'object') {
                            if (rule[k].search.op) {
                                key += '[' + rule[k].search.op + ']';
                            }
                            condition[key] = rule[k].search.value ? rule[k].search.value.replace('{value}', params[k]) : params[k];
                        } else {
                            condition[key] = params[k];
                        }
                    }
                }
            }
        }
        if ((this.model.primary_key === 'student_id' || this.model.primary_key === 'group_id')
                && params.academic_year == null && this.currentAcademyYearValue) {
            condition.academic_year = this.currentAcademyYearValue;
        }
        if (params.hasOwnProperty('academic_year') && params.academic_year === '') {
            delete condition.academic_year;
        }
        if (params.report_start_date) {
            let startDate = params.report_start_date;
            delete condition.report_start_date;
            condition['activity_date[gte]'] = startDate;
        }
        if (params.report_end_date) {
            let endDate = params.report_end_date;
            delete condition.report_end_date;
            condition['activity_date[lte]'] = endDate;
        }
        if (params.school_id && params.school_id.split(',').length > 1) {
          condition['school_id[in]'] = params.school_id;
          delete condition.school_id;
        }

        if (this.isReferOtherRole() && (
                this.appGlobal.refer_role === this.appGlobal.roleMentor ||
                this.appGlobal.refer_role === this.appGlobal.roleSchoolAdmin
            )
        ) {
            condition.school = this.appGlobal.refer_schoolCurrentUserLogin;
        }
        condition = this.rebuild(condition);
        return condition;
    }

    rebuild(condition) {
        if (condition && condition['where']) {
            const wheres = condition['where'].split('&');
            for (const w of wheres) {
                const arr = w.split('=');
                if (arr.length == 2) {
                    condition[arr[0]] = arr[1];
                }
            }
            delete condition['where'];
        }
        return condition;
    }



    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/application/web-components/shared/admin_table.component.ts